import { Stack, LinearProgress } from '@mui/material';
import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NetworkErrorBoundary } from 'rest-hooks';
import { TestRunner } from '../../evaluateRunner/evaluateRunner';
import NavBar from '../navbar';
import { CompactHeaderBar } from './compactHeaderBar';
import { InputSourceBar } from './inputSourceBar';

export const CompactLayout = () => {
  const isXmlPage = useLocation().pathname.startsWith('/xml');
  return (
  <Stack direction={'row'} sx={{ height: '100vh', width: '100vw', bgcolor: 'background.default' }}>
    <NavBar />
    <Stack direction={'column'} flexGrow={1} sx={{ overflow: 'hidden', minWidth: 0 }}>
      <CompactHeaderBar />
      <Suspense fallback={<LinearProgress />}>
        <InputSourceBar />
      </Suspense>
      <main style={{ display: 'flex', flexGrow: 1, minHeight: 0 }}>
        <Stack
          direction={'row'}
          flexGrow={1}
          minWidth={0}
          sx={
            isXmlPage
              ? { '& > *': { flex: '1 1 0', minWidth: 0 } }
              : {
                  '& > *': { flex: '0 0 70%', width: '70%', minWidth: 0, display: 'flex' },
                  '& > * > *': { flex: '1 1 0', width: '50%', minWidth: 0 },
                  '& > *:last-child': { flex: '0 0 30%', width: '30%' },
                  '& > *:last-child > *': { flex: 'none', width: '100%' }
                }
          }>
          <Suspense fallback={<LinearProgress />}>
            <NetworkErrorBoundary fallbackComponent={() => <p>Error</p>}>
              <Outlet />
            </NetworkErrorBoundary>
          </Suspense>
          {!isXmlPage && (
            <Suspense fallback={<LinearProgress />}>
              <NetworkErrorBoundary fallbackComponent={() => <p>Error</p>}>
                <TestRunner />
              </NetworkErrorBoundary>
            </Suspense>
          )}
        </Stack>
      </main>
    </Stack>
  </Stack>
  );
};
